import { makeAutoObservable, runInAction } from 'mobx';

import { toast } from 'react-toastify';

import SubscriptionService from '../services/SubscriptionService';
import NotificationsService from '../services/NotificationsService';
import { notificationFrequencyTypes } from 'constants/enums';
import { RootStore } from './RootStore';

export class SubscriptionStore {
  subscriptionService: InstanceType<typeof SubscriptionService>;
  notificationService: InstanceType<typeof NotificationsService>;
  subscriptions = [];
  status: string;

  constructor(private rootStore: RootStore) {
    this.subscriptionService = new SubscriptionService();
    this.notificationService = new NotificationsService();
    makeAutoObservable(this, {}, { autoBind: true });
  }

  getSubscriptions = async () => {
    runInAction(() => this.rootStore.spinnerStore.showSpinner());
    try {
      const response = await this.subscriptionService.getAllSubscriptions();
      if (response && response.status === 200) {
        return response;
      }
    } catch (error: any) {
      runInAction(() => {
        this.status = 'error';
      });
      const message = error?.data?.title || 'Failed to subscribe';
      toast.error(message);
    } finally {
      runInAction(() => this.rootStore.spinnerStore.hideSpinner());
    }
  };

  updateSubscriptions = () => this.getSubscriptions();
  getNotificationFriquency = async () => {
    runInAction(() => this.rootStore.spinnerStore.showSpinner());
    try {
      const response = await this.notificationService.currentNotificationFriquency();
      if (response && response.status === 200) {
        return response.data;
      }
    } catch (error: any) {
      runInAction(() => {
        this.status = 'error';
      });
      const message = error?.data?.title || 'Failed to get notification friquency';
      toast.error(message);
    } finally {
      runInAction(() => this.rootStore.spinnerStore.hideSpinner());
    }
  };
  updateNotificationFriquency = async (type: {
    notificationsFrequency: (typeof notificationFrequencyTypes)[number]['value'];
  }) => {
    runInAction(() => this.rootStore.spinnerStore.showSpinner());
    try {
      const response = await this.notificationService.updateNotificationFriquency(type);
      if (response && response.status === 200) {
        return response.data;
      }
    } catch (error: any) {
      runInAction(() => {
        this.status = 'error';
      });
      const message = error?.data?.title || 'Failed to update notification friquency';
      toast.error(message);
    } finally {
      runInAction(() => this.rootStore.spinnerStore.hideSpinner());
    }
  };
}
